/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosTable, CosmosText } from "@cosmos/components";

import type { PartnerAttributeRow } from "./buildServicePartnerDetailView";

export interface PartnerAttributeTableProps {
	rows: PartnerAttributeRow[];
}

/**
 * Two-column attribute table for the Service Partner detail page — one row per
 * non-empty multi-value column (industries, support type, UE skills, etc.),
 * label in the first cell, the dot-joined values in the second. Renders nothing
 * when there are no rows.
 */
export function PartnerAttributeTable({ rows }: PartnerAttributeTableProps): React.JSX.Element | null {
	if (rows.length === 0) return null;

	return (
		<CosmosTable gridTemplateColumns="1fr 2fr">
			<CosmosTable.Body w="full">
				{rows.map((row) => (
					<CosmosTable.Row key={row.label}>
						<CosmosTable.Cell>
							<CosmosText variant="headingSM" color="eds.text.primary" text={row.label} />
						</CosmosTable.Cell>
						<CosmosTable.Cell>
							<CosmosText variant="uiSM" color="eds.text.primary" text={row.values.join(" · ")} />
						</CosmosTable.Cell>
					</CosmosTable.Row>
				))}
			</CosmosTable.Body>
		</CosmosTable>
	);
}
